var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:assets' to update
import Asset from '../asset-internal';
function MlflowLogomark(_a) {
    var restProps = __rest(_a, []);
    return (_jsxs(Asset, Object.assign({ viewBox: "0 0 24 24" }, restProps, { children: [_jsx("path", { opacity: ".8", d: "M18.95 2.176a12.045 12.045 0 0 0-16.393 17.29l3.668-2.694A7.572 7.572 0 0 1 12.042 4.45l-.087 2.867 6.996-5.14Z", fill: "currentColor" }), _jsx("path", { d: "M21.664 4.852a10.557 10.557 0 0 0-.38-.493l-3.532 2.606a7.572 7.572 0 0 1-5.516 12.648l.087-2.864-7.074 5.212A12.03 12.03 0 0 0 21.68 4.878l-.015-.026Z", fill: "currentColor" })] })));
}
export default MlflowLogomark;
